import * as React from "react"

const NoStatsFound = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.625 14.025L1 12.85L6 4.85L9 8.35L13 1.85L16 6.35L19.375 1L21 2.175L16.05 10.025L13.075 5.55L9.275 11.725L6.25 8.2L2.625 14.025ZM14.5 18C15.2 18 15.7917 17.7583 16.275 17.275C16.7583 16.7917 17 16.2 17 15.5C17 14.8 16.7583 14.2083 16.275 13.725C15.7917 13.2417 15.2 13 14.5 13C13.8 13 13.2083 13.2417 12.725 13.725C12.2417 14.2083 12 14.8 12 15.5C12 16.2 12.2417 16.7917 12.725 17.275C13.2083 17.7583 13.8 18 14.5 18ZM19.6 22L16.9 19.3C16.55 19.5333 16.1708 19.7083 15.7625 19.825C15.3542 19.9417 14.9333 20 14.5 20C13.25 20 12.1875 19.5625 11.3125 18.6875C10.4375 17.8125 10 16.75 10 15.5C10 14.25 10.4375 13.1875 11.3125 12.3125C12.1875 11.4375 13.25 11 14.5 11C15.75 11 16.8125 11.4375 17.6875 12.3125C18.5625 13.1875 19 14.25 19 15.5C19 15.9333 18.9417 16.3542 18.825 16.7625C18.7083 17.1708 18.5333 17.55 18.3 17.9L21 20.6L19.6 22Z" />
  </svg>
)

export default NoStatsFound
